<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="false"
    (onBack)="onClose()"
    [showDefaultBtns]="true"
    [showAddBtn]="false"
    [showRefreshBtn]="false"
    [showAuditBtn]="false"
    [showHelpBtn]="false"
    [showBackBtn]="true"
  >
  </app-page-header>

  <div class="row app-page-content">
    <div class="xl:tw-w-5/6 offset-xl-1">
      <div class="row" [class.d-none]="statType == 'survey'">
        <div class="md:tw-w-1/3 p-2">
          <div
            class="tw-flex tw-justify-evenly tw-p-4 border-field border-radius bg-bright-blue"
          >
            <span class="text-blue">{{ "common.allCount" | translate }} :</span>
            <span class="text-blue">{{ model.totalAnswerCount }}</span>
          </div>
        </div>
        <div class="md:tw-w-1/3 p-2">
          <div
            class="tw-flex tw-justify-evenly tw-p-4 border-field border-radius bg-bright-success"
          >
            <span class="text-success"
              >{{
                "pages.pollParsers.stats.correctAnswerCount" | translate
              }}
              :</span
            >
            <span class="text-success">{{ model.correctAnswerCount }}</span>
          </div>
        </div>
        <div class="md:tw-w-1/3 p-2">
          <div
            class="tw-flex tw-justify-evenly tw-p-4 border-field border-radius bg-bright-danger"
          >
            <span class="text-danger"
              >{{
                "pages.pollParsers.stats.incorrectAnswerCount" | translate
              }}
              :</span
            >
            <span class="text-danger">{{ model.incorrectAnswerCount }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="md:tw-w-10/12 offset-md-1">
      <div class="row">
        <div class="tw-w-full">
          <div class="tw-flex tw-justify-center">
            <table
              class="table table-row-bordered tw-mt-3 bg-white"
              style="border-style: ridge"
              *ngIf="model.items?.length"
            >
              <tr>
                <th class="tw-text-center p-3">
                  {{ "common.text" | translate }}
                </th>
                <th class="tw-text-center p-3">
                  {{ "common.count" | translate }}
                </th>
              </tr>
              <ng-container *ngFor="let item of model.items">
                <tr>
                  <td class="tw-text-center p-3 font-vazir-ui">{{ item.smsText }}</td>
                  <td class="tw-text-center p-3">{{ item.count }}</td>
                </tr>
              </ng-container>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- charts -->
    <div class="row">
      <div class="tw-w-full">
        <div class="row">
          <div
            [class.md:tw-w-full]="statType == 'survey'"
            [class.col-md-6]="statType != 'survey'"
          >
            <app-parser-stats-doughnut-chart
              [model]="model"
              [chartId]="doughnutChartId"
            >
            </app-parser-stats-doughnut-chart>
          </div>
          <div class="md:tw-w-1/2" [class.d-none]="statType == 'survey'">
            <app-parser-stats-pie-chart [model]="model" [chartId]="pieChartId">
            </app-parser-stats-pie-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-body>
